/* JVC Store — comportamiento de las secciones jvc-* */
(() => {
  // Carrusel deslizable con flechas, puntos y autoplay opcional.
  if (!customElements.get('jvc-carousel')) {
    class JvcCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.jvc-carousel__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dotsWrap = this.querySelector('.jvc-carousel__dots');
        this.querySelector('.jvc-carousel__arrow--prev')?.addEventListener('click', () => this.go(this.index() - 1));
        this.querySelector('.jvc-carousel__arrow--next')?.addEventListener('click', () => this.go(this.index() + 1));
        if (this.dotsWrap && this.slides.length > 1) {
          this.dots = this.slides.map((_, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'jvc-carousel__dot';
            b.setAttribute('aria-label', `Ir a ${i + 1}`);
            b.addEventListener('click', () => this.go(i));
            this.dotsWrap.appendChild(b);
            return b;
          });
        }
        this.track.addEventListener('scroll', () => this.mark(), { passive: true });
        this.mark();
        const ms = parseInt(this.dataset.autoplay || '0', 10);
        if (ms > 0 && this.slides.length > 1) {
          const stop = () => clearInterval(this.timer);
          this.timer = setInterval(() => this.go(this.index() + 1 >= this.slides.length ? 0 : this.index() + 1), ms);
          ['pointerdown', 'touchstart', 'mouseenter'].forEach((e) => this.addEventListener(e, stop, { passive: true, once: true }));
        }
      }
      index() {
        const left = this.track.scrollLeft;
        let best = 0;
        let dist = Infinity;
        this.slides.forEach((s, i) => {
          const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left - (this.track.clientWidth - s.clientWidth) / 2);
          if (d < dist) { dist = d; best = i; }
        });
        return best;
      }
      go(i) {
        const n = this.slides.length;
        const s = this.slides[((i % n) + n) % n];
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft - (this.track.clientWidth - s.clientWidth) / 2, behavior: 'smooth' });
      }
      mark() {
        if (!this.dots) return;
        const i = this.index();
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      }
    }
    customElements.define('jvc-carousel', JvcCarousel);
  }

  // Barras de estadísticas: se llenan al entrar en pantalla.
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      }), { threshold: 0.25 })
    : null;
  const watch = () => document.querySelectorAll('.jvc-stats:not(.is-visible)').forEach((el) => (io ? io.observe(el) : el.classList.add('is-visible')));
  watch();
  document.addEventListener('shopify:section:load', watch);

  // Contador de oferta: X minutos por visitante (se guarda en el navegador) o hasta la medianoche.
  const two = (n) => String(n).padStart(2, '0');
  const store = {
    get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} },
  };
  const deadline = (el) => {
    const now = Date.now();
    if (el.dataset.mode === 'midnight') {
      const d = new Date();
      d.setHours(24, 0, 0, 0);
      return d.getTime();
    }
    const key = `jvc-cd-${el.dataset.key || 'x'}`;
    let end = parseInt(store.get(key) || '0', 10);
    if (!end || end <= now) {
      end = now + parseInt(el.dataset.minutes || '15', 10) * 60000;
      store.set(key, String(end));
    }
    return end;
  };
  const tick = () => document.querySelectorAll('[data-jvc-countdown]').forEach((el) => {
    if (!el._end || el._end <= Date.now()) el._end = deadline(el);
    const s = Math.max(0, Math.floor((el._end - Date.now()) / 1000));
    el.textContent = `${two(Math.floor(s / 3600))}:${two(Math.floor((s % 3600) / 60))}:${two(s % 60)}`;
  });
  tick();
  setInterval(tick, 1000);

  // Fechas de entrega: se calculan desde hoy ("3 nov", "3 nov - 4 nov").
  const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const fecha = (dias, sinDomingo) => {
    const d = new Date();
    let n = dias;
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (!(sinDomingo && d.getDay() === 0)) n -= 1;
    }
    return `${d.getDate()} ${MESES[d.getMonth()]}`;
  };
  const fillDates = () => document.querySelectorAll('[data-jvc-timeline] .jvc-timeline__date').forEach((el) => {
    const a = parseInt(el.dataset.from || '0', 10);
    const b = parseInt(el.dataset.to || '0', 10);
    const sd = el.closest('[data-jvc-timeline]').hasAttribute('data-skip-sunday');
    el.textContent = b > a ? `${fecha(a, sd)} - ${fecha(b, sd)}` : fecha(a, sd);
  });
  fillDates();
  document.addEventListener('shopify:section:load', fillDates);

  // Botones "Ordenar": abren el formulario contra entrega de Releasit.
  // Si Releasit no está, suben hasta el formulario del producto.
  document.addEventListener('click', (ev) => {
    const a = ev.target.closest('[data-jvc-order]');
    if (!a) return;
    ev.preventDefault();
    const rsi = document.getElementById('_rsi-buy-now-button');
    if (rsi) { rsi.click(); return; }
    const form = document.querySelector('product-info .product-form, product-info form[action*="/cart/add"]');
    (form || document.querySelector('product-info'))?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
